import { Injectable } from '@angular/core';
import { PresupuestoServiceInterface } from '../seg-presupuestal-factory';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { companiesSegPresupuestal } from '../../../shared/catalogos';

// Archivo para la implementacion de consultas para el backend que trabaja con IA 
//Deben estar implementados todoso los metodos especificador en seg-presupuestal-factory

@Injectable()
//Cuando se quiera implementar un segundo backend se descomenta la linea de abajo para que la class herede e implemente la interfaz que conecta ambs backs 
// export class PresupuestoIaService implements PresupuestoServiceInterface {
export class PresupuestoIaService {
  private readonly apiURL = environment.api_proyecciones;
  private headers = new HttpHeaders().append('Content-Type', 'application/json'); 
  constructor(
    private http: HttpClient,
  ) { }

  public getSucursales(instId): Observable<any>{
    const id = companiesSegPresupuestal.find(i => i.id === instId).idBack;
    const inst = {
      institutionid: id, 
    }
    const body = JSON.stringify(inst);
    const apiURL = this.apiURL + 'api/Listsucursal';
    return this.http.post(apiURL, body, { headers: this.headers});
  }

  public getCuentas(id: number): Observable <any>{
    const tmp = {
      templateid: id
    }
    const body = JSON.stringify(tmp);
    const apiURL = this.apiURL + 'api/ListCuentas';
    return this.http.post(apiURL, body, { headers: this.headers});
  }
}
